// extracted by mini-css-extract-plugin
export default {"pagination":"SuperPagination_pagination__m6PUc","text1":"SuperPagination_text1__TyHBQ","text2":"SuperPagination_text2__zLJJK"};